import React from 'react'
// import {useState} from 'react'
// import * as FaIcons from 'react-icons/fa';
// import * as AiIcons from 'react-icons/ai';
// import * as IoIcons from 'react-icons/io';
import DetailsIcon from '../IMAGES/Icons/VectorDetails.png'
import InvoiceIcon from '../IMAGES/Icons/VectorInvoice.png'
import HomeIcon from '../IMAGES/Icons/VectorHome.png'
import ProjectIcon from '../IMAGES/Icons/VectorProject.png'
import ContractIcon from '../IMAGES/Icons/VectorContract.png'

export const SidebarData = [
    
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: require('../IMAGES/Icons/VectorHome.png'),
        cName: 'nav-text',
        no:0
        
    },
    {
        title: 'Projects' ,
        path: '/Projects',
        icon: require('../IMAGES/Icons/VectorProject.png'),
        cName: 'nav-text',
        no:1,
    },
    // {
    //     title: 'Invoice' ,
    //     path: '/Invoice',
    //     icon: require('../IMAGES/Icons/VectorInvoice.png'),
    //     cName: 'nav-text',
    //     no:2,
    //     for:['CONSULTANT','ACCOUNTANT']
    // },
    {
        title: 'Details' ,
        path: '/details',
        icon: require('../IMAGES/Icons/VectorDetails.png'),
        cName: 'nav-text',
        no:3
    },
    // {
    //     title: 'Contracts' ,
    //     path: '/contracts',
    //     icon: require('../IMAGES/Icons/VectorContract.png'),
    //     cName: 'nav-text' ,
    //     no:4,
    //     for:['CONSULTANT','HR']
    // },
]
        